(function ($) {
  $(() => {
    const subscriptionForm = $(".js-newsletter-subscribe");

    if (!subscriptionForm.length) {
      return;
    }

    const successMessage = $('.js-newsletter-success-message');

    subscriptionForm.submit((e) => {
      e.preventDefault();
      $('.js-mailchimp-message').hide();
      const formData = subscriptionForm.serializeArray();

      $.ajax({
        url: localize.ajaxurl,
        type: "POST",
        data: {
          action: "submit_newsletter_form",
          datas: formData,
        },
        error(error) {
          console.error(error);
        },
        success(data) {
          const result = JSON.parse(data);
          const fields = [...new Set(result.fields)];

          if (result.status == "success") {
            subscriptionForm.trigger("reset").hide();
            successMessage.show();
          } else if(result.status == "mailchimp_error") {
              $('.js-mailchimp-message').show();
          } else {
            $(fields).each((i, e) => {
              subscriptionForm
                .find(`[name=${e.field}]`)
                .closest(".js-input-group")
                .addClass("has-error");
              subscriptionForm
                .find(`[name=${e.field}]`)
                .nextAll(".js-error-message")
                .text(e.message);
            });
          }
        },
      });
    });
  });
})(jQuery);
